<!--工单管理,可以作废删除工单-->
<template>
  <treeBody>
    <listView ref="listView" slot="tree" style="width:99%;height: 100%;" :dataList="orderDefineList"
      @checkItem="nowOrderDefine = $event"></listView>
    <div slot="body" style="width: 100%;height: 100%;flex-direction: column;overflow-x: hidden;"
      class="flexStart custom-scrollbar">
      <div class="filterDiv">
        <div>
          <span>筛选条件:</span>
          <p v-for="item in filterList" @click="nowFilter[item.id] = !nowFilter[item.id],openFilter=true"
            :class="{isCheck:nowFilter[item.id]}">{{item.name}}</p>
          <iconButton icoName="wedoButton/search.png" buttonText="查询" @buttonClick="seachOrder"></iconButton>
          <iconButton
            v-show='nowFilter.orderGroup || nowFilter.state || nowFilter.priority ||nowFilter.startTime || nowFilter.endTime'
            :icoName="openFilter?'wedoButton/delete.png':'wedoButton/add.png'" :buttonText="openFilter?'收起筛选':'显示筛选'"
            @buttonClick="openFilter = !openFilter" style="position: absolute;right: 10px;"></iconButton>
        </div>
        <div v-show="nowFilter.orderGroup && openFilter">
          <span>工单分组:</span>
          <p v-for="item in $store.orderGroupStore.getters.getOrderGroupTree" @click="orderGroupIds = [item.groupId]"
            :class="{isCheck:orderGroupIds.includes(item.groupId)}">{{item.name}}</p>
        </div>
        <div v-show="nowFilter.state&& openFilter">
          <span>工单状态:</span>
          <p v-for="item in nowStateList" @click="nowStatus = item.value" :class="{isCheck:item.value == nowStatus}">
            {{item.name}}</p>
        </div>
        <div v-show="nowFilter.priority&& openFilter">
          <span>优先级:</span>
          <p v-for="item in $store.orderGroupStore.state.priorityList" @click="nowPriority = item.value"
            :class="{isCheck:item.value == nowPriority}">{{item.name}}</p>
        </div>
        <div v-show="(nowFilter.startTime ||nowFilter.endTime) && openFilter">
          <span v-show="nowFilter.startTime">开始时间:</span>
          <datePicker v-show="nowFilter.startTime" class="marginLeft" dateType="dateTime" :initDate="startTime"
            @checkDate="startTime = $event"></datePicker>
          <span v-show="nowFilter.endTime">截至时间:</span>
          <datePicker v-show="nowFilter.endTime" class="marginLeft" dateType="dateTime" :initDate="endTime"
            @checkDate="endTime = $event"></datePicker>
        </div>
      </div>
      <infoList style="height: calc(100% - 50px);width: 100%;" ref="infoList" @checkItem="nowOrder = $event"
        :columns='columns' :dataList="nowPage" :pageLen='pageLen' :totalSize="totalSize" @selectPage="selectPage"
        :fillAll="true">
        <div slot="delete" slot-scope="slotProps" v-show="slotProps.item != undefined">
          <u class="intoButton" @click.stop="invalidOrder(slotProps.item)"
            v-show="slotProps.item != undefined && slotProps.item.status != 'Deleted'">作废</u>
          <u class="intoButton" @click.stop="deleteOrder(slotProps.item)"
            v-show="slotProps.item != undefined && slotProps.item.status == 'Deleted'"
            style="margin-right: 10px;">删除</u>
          <u class="intoButton" @click.stop="restoreByOrderIds(slotProps.item)"
            v-show="slotProps.item != undefined && slotProps.item.status == 'Deleted'">恢复</u>
        </div>
      </infoList>
    </div>
  </treeBody>
</template>

<script>
  import singleSelection from '@/components/module/selection/base/singleSelection.vue'
  import multipleSelection from '@/components/module/selection/multipleSelection.vue'
  import treeBody from '@/components/module/slotModule/treeBody.vue'
  import infoList from '@/components/module/universal/infoList.vue'
  import listView from '@/components/module/selection/base/listView.vue'
  import datePicker from '@/components/module/datePicker/base/datePicker.vue'
  import iconButton from '@/components/module/universal/iconButton.vue'
  export default {
    components: {
      treeBody,
      infoList,
      listView,
      singleSelection,
      multipleSelection,
      datePicker,
      iconButton
    },
    props: {},
    data () {
      return {
        nowPage: [{
          orderId: 12,
          name: "上周工单",
          creatorName: '1',
          item: 1,
          createTime: '2023-03-05',
          status: 1,
          startTime: '2023-04-01',
          createTime: '2024-07-08',
          updateTime: '2024-07-18',
        }],
        orderDefineList: [{
          name: '所有工单',
          type: 'all'
        },{
          name: '周期工单',
          type: 'CycleOrder'
        }],
        nowOrderDefine: undefined,
        nowStatus: undefined,
        nowPriority: undefined,
        nowFilter: {
          orderGroup: false,
          state: false,
          priority: false,
          startTime: false,
          endTime: false
        },
        openFilter: true,
        filterList: [{
          name: '工单分组',
          id: 'orderGroup'
        },{
          name: '工单状态',
          id: 'state'
        },{
          name: '优先级',
          id: 'priority'
        },{
          name: '开始时间',
          id: 'startTime'
        },{
          name: '截止时间',
          id: 'endTime'
        }],
        //当前选中的分组的id数组，单人版本只允许单个
        orderGroupIds: [],
        pageLen: 100,
        nowOrder: [],
        nowIndex: 0,
        orderListByIndex: [], //每一页的记录,修改查询内容后查询就会清空
        startTime: new Date(),
        endTime: new Date(),
        totalSize: 0,
      }
    },
    mounted () {
      debugPage=this
      this.nowOrderDefine=this.orderDefineList[0]
      this.$refs.listView.setNowItem(this.orderDefineList[0])
      this.seachOrder()
    },
    computed: {

      columns () {
        var baseList=[{
          name: '单号',
          key: 'orderId',
          weight: 1.2
        },{
          name: '名称',
          key: 'title',
          weight: 1.4,
        },{
          name: '创建人',
          key: 'creatorName'
        },{
          name: '分组',
          key: 'groupId',
          format: item => {
            return getValueIfNoNull(this.$store.orderGroupStore.getters.getOrderGroupByGroupId(item),{
              name: '未分组'
            }).name
          }
        },{
          name: '优先级',
          key: 'groupId',
          format: item => {
            var group=this.$store.orderGroupStore.getters.getOrderGroupByGroupId(item)
            if(group==undefined) {
              return '--'
            }
            var priority=this.$store.orderGroupStore.getters.getPriorityByValue(group.priority)
            return getValueIfNoNull(priority,{
              name: '--'
            }).name
          }
        },{
          name: '创建时间',
          key: 'createTime',
          format (item) {
            return new Date(item).formatByTime()
          },
          weight: 1.4,
        }]
        if(this.nowOrderDefine==undefined||[undefined,'all','copyToMe','iCreated','myNode'].includes(this.nowOrderDefine
          .type)) {
          baseList.insert(2,{
            name: '状态',
            key: 'status',
            format: item => {
              return this.$store.orderStore.getters.getStateNameByStatus(item)
            }
          })
          baseList.push({
            name: '开始时间',
            key: 'startTime',
            format (item) {
              return new Date(item).formatByTime()
            },
            weight: 1.4,
          })
          baseList.push({
            name: '截止时间',
            key: 'createTime',
            format (item) {
              return new Date(item).formatByTime()
            },
            weight: 1.4,
          })
          baseList.push({
            name: '最后编辑时间',
            key: 'updateTime',
            format (item) {
              return new Date(item).formatByTime()
            },
            weight: 1.4,
          })
          baseList.push({
            name: '操作',
            type: 'slot',
            key: 'delete'
          })
        } else if(this.nowOrderDefine.type=='CycleOrder') {
          baseList.insert(6,{
            name: '上次生成时间',
            key: 'cycleTime',
            format (item) {
              return new Date(item).formatByTime()
            },
            weight: 1.4,
          })
          baseList.push({
            name: '下次生成时间',
            key: 'cycleTime',
            format (item,data) {
              return new Date(item+data.workDay).formatByTime()
            },
            weight: 1.4,
          })
          baseList.push({
            name: '操作',
            type: 'slot',
            key: 'delete'
          })
        }
        return baseList
      },
      nowStateList () {
        return this.$store.orderStore.state.stateList
      }
    },
    watch: {
      nowOrderDefine (nv,ov) {
        this.seachOrder()
      }
    },
    methods: {
      selectPage (index) {
        this.nowIndex=index
        if(isempty(this.nowPage)) {
          this.seachOrder()
        }
      },
      seachOrder () {
        //个人版只能查询部分内容
        //判断参与人类型
        var myId=this.$store.userStore.state.nowUserInfo.id
        var creatorIds=undefined
        var nodeUsers=undefined
        var participants=undefined
        switch(this.nowOrderDefine.type) {
          case 'all':
            break
          case 'copyToMe':
            participants=myId
            break
          case 'iCreated':
            creatorIds=myId
            break
          case 'myNode':
            nodeUsers=myId
            break
        }
        //排除多余的检查项
        var orderGroupIds=undefined
        if(this.nowFilter.orderGroup) {
          orderGroupIds=this.orderGroupIds.join(',')
        }
        var nowStatus=undefined
        if(this.nowFilter.state) {
          nowStatus=this.nowStatus
        }
        var nowPriority=undefined
        if(this.nowFilter.priority) {
          nowPriority=this.nowPriority
        }
        var startTime=undefined
        if(this.nowFilter.startTime) {
          startTime=this.startTime.getTime()
        }
        var endTime=undefined
        if(this.nowFilter.endTime) {
          endTime=this.endTime.getTime()
        }
        //判断工单类型
        var orderType='Order'
        if(this.nowOrderDefine!=undefined&&['CycleOrder','OrderTemplate'].includes(this.nowOrderDefine.type)) {
          orderType=this.nowOrderDefine.type
          creatorIds=myId
        }
        this.$api.orderApi.searchByType(this.nowIndex+1,this.pageLen,orderGroupIds,orderType,nowStatus,nowPriority,
          creatorIds,nodeUsers,participants,startTime,endTime,undefined,respon => {
            this.totalSize=respon.total
            this.$set(this.orderListByIndex,this.nowIndex,respon.dataList)
            if(orderType=='OrderTemplate') {
              this.$store.orderStore.commit('getOrderTemplateList')
            }
          })
      },
      intoOrder (order) {
        //进入工单
        this.$store.orderStore.commit('setNowOrder',order)
        this.$router.push('/dealOrder')
      },
      invalidOrder (order) {
        this.$api.orderApi.removeByOrderIds(order.orderId,'用户 '+this.$store.userStore.state.nowUserInfo.username+
          ' 将其置为作废',respon => {
            order.status='Deleted'
            order.updateTime=new Date().formatByTime()
            var list=this.orderListByIndex[this.nowIndex]
            this.$set(list,list.findIndex(item => {
              return item.orderId==order.orderId
            }),order)
            this.$dialogMethod.showMessage('作废成功!')
          },err => {
            this.$message({
              type: 'error',
              message: err
            });
          })
      },
      deleteOrder (order) {
        this.$api.orderApi.deleteByOrderIds(order.orderId,respon => {
          var list=this.orderListByIndex[this.nowIndex]
          this.$set(this.orderListByIndex,this.nowIndex,list.filter(item => {
            return item.orderId!=order.orderId
          }))
          this.$dialogMethod.showMessage('删除成功!')
        })
      },
      restoreByOrderIds (order) {
        this.$api.orderApi.restoreByOrderIds(order.orderId,respon => {
          order.status=order.rawStatus
          var list=this.orderListByIndex[this.nowIndex]
          this.$set(list,list.findIndex(item => {
            return item.orderId==order.orderId
          }),order)
          this.$dialogMethod.showMessage('恢复成功!')
        })
      }
    }
  }
</script>

<style scoped>
  .marginLeft {
    margin: 0 10px;
  }

  .intoButton {
    color: #DA7800;
    text-align: center;
    cursor: pointer;
  }

  .filterDiv {
    background: white;
    width: calc(100% - 20px);
    padding: 0 10px;
  }

  .filterDiv>div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    border-bottom: silver 1px dashed;
  }

  .filterDiv>div>p {
    font-size: .12rem;
    padding: 2px 5px;
    cursor: pointer;
    margin: 5px 10px;
    border-radius: 10px;
  }

  .filterDiv>div>p.isCheck {
    color: white;
    background: #DA7800;
  }

  .filterDiv>div>span {
    font-size: .12rem;
    padding: 5px 10px;
    color: #7f7f7f;
    min-width: 60px;
  }

  .filterDiv>>>.wedoButton-body {
    background: silver;
  }
</style>